import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { CommonService } from "../../../../shared/services/common.service";

@Component({
  selector: 'app-user-attendance',
  templateUrl: './user-attendance.component.html',
  styleUrls: ['./user-attendance.component.css']
})
export class UserAttendanceComponent implements OnInit, OnChanges {
  @Input() user: any;
  @Input() form: any;
  @Input() disabled: boolean = false;

  errorMessages: any = {};
  errorMessageMap = {
    type: {
      required: 'This field is required'
    }
  };

  isPresentValueReverseMap = {
    true: 1,
    false: 2
  };

  constructor(
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.initializeAttendance();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['disabled'] || changes['user'] || changes['form']) {
      this.initializeAttendance();
    }
  }

  private initializeAttendance() {
    if (this.user && this.form) {
      // Set the attendance type value
      const typeValue = this.isPresentValueReverseMap[this.user?.isPresent];
      if (typeValue !== undefined) {
        this.form?.patchValue({
          type: typeValue,
          typeMobile: typeValue
        }, { emitEvent: true });
      }
      
      // Handle disabled state
      if (this.disabled) {
        this.form?.get('type')?.disable();
      } else {
        this.form?.get('type')?.enable();
      }
    }
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }
} 